export const currenciesWhiteList: string[] = ['EUR', 'GBP', 'USD', 'PLN'];

